import React from 'react'
import { Link } from 'react-router-dom'
import { useHeader, HeaderProps } from './useHeader'
import getLanguageFromUrl from 'utils/getLanguageFromUrl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './Header.module.scss'

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const {
    isLoading,
    scrolled,
    isMobileNavActive,
    isLanguageDdlDisplayed,
    isInnerPage,
    t,
    isHighlighted,
    toggleMobileNav,
    toggleLanguageDdl,
    handleChangeLanguage,
  } = useHeader(props)

  const selectedLanguage = getLanguageFromUrl()

  return (
    <header
      id='header'
      className={`${styles.header} ${isMobileNavActive ? styles['mobile-nav-active'] : ''} ${isInnerPage ? styles['inner-layout'] : ''} ${scrolled ? styles.scrolled : ''} d-flex align-items-center fixed-top ${isLoading ? 'd-none' : ''}`}
    >
      <div
        className={`${styles['header-container']} container-fluid container-xl position-relative d-flex align-items-center justify-content-between`}
      >
        <Link
          to={`/${selectedLanguage}`}
          className={`${styles.logo} d-flex align-items-center`}
        >
          <img src='/img/Logos/logo.png' alt='logo' height={85} />
        </Link>
        <nav id='navmenu' className={styles.navmenu}>
          <ul>
            <li>
              <Link
                to={`/${selectedLanguage}`}
                onClick={() => toggleMobileNav(false)}
                className={
                  isHighlighted(`/${selectedLanguage}`) ? styles.active : ''
                }
              >
                {t('navHome')}
              </Link>
            </li>
            <li>
              <Link
                to={`/${selectedLanguage}/About`}
                onClick={() => toggleMobileNav(false)}
                className={
                  isHighlighted(`/${selectedLanguage}/About`)
                    ? styles.active
                    : ''
                }
              >
                {t('navAboutUs')}
              </Link>
            </li>
            <li>
              <Link
                to={`/${selectedLanguage}/Departments`}
                onClick={() => toggleMobileNav(false)}
                className={
                  isHighlighted(`/${selectedLanguage}/Departments`)
                    ? styles.active
                    : ''
                }
              >
                {t('navDepartments')}
              </Link>
            </li>
            <li>
              <Link
                to={`/${selectedLanguage}/News`}
                onClick={() => toggleMobileNav(false)}
                className={
                  isHighlighted(`/${selectedLanguage}/News`)
                    ? styles.active
                    : ''
                }
              >
                {t('navNews')}
              </Link>
            </li>
            <li>
              <Link
                to={`/${selectedLanguage}/OurTeam`}
                onClick={() => toggleMobileNav(false)}
                className={
                  isHighlighted(`/${selectedLanguage}/OurTeam`)
                    ? styles.active
                    : ''
                }
              >
                {t('navOurTeam')}
              </Link>
            </li>
            <li>
              <Link
                to={`/${selectedLanguage}/Contact`}
                onClick={() => toggleMobileNav(false)}
                className={
                  isHighlighted(`/${selectedLanguage}/Contact`)
                    ? styles.active
                    : ''
                }
              >
                {t('navContactUs')}
              </Link>
            </li>
            <li>
              <Link
                to={`/${selectedLanguage}/Support`}
                onClick={() => toggleMobileNav(false)}
                className={
                  isHighlighted(`/${selectedLanguage}/Support`)
                    ? styles.active
                    : ''
                }
              >
                {t('navDonate')}
              </Link>
            </li>
            <li className={styles.dropdown}>
              <a
                href='#'
                className={
                  window.innerWidth < 1200 && isLanguageDdlDisplayed
                    ? styles.active
                    : ''
                }
                onClick={() => toggleLanguageDdl()}
              >
                <span>
                  <FontAwesomeIcon
                    icon='globe'
                    size='lg'
                    style={{ marginInlineEnd: '5px' }}
                  />

                  {t('language')}
                </span>{' '}
                <FontAwesomeIcon
                  icon='angle-down'
                  size='lg'
                  className={styles['angle-icon']}
                  style={{ marginInlineStart: '5px' }}
                />
              </a>
              <ul
                className={`${styles['language-ddl']} ${window.innerWidth < 1200 && isLanguageDdlDisplayed ? 'd-block' : window.innerWidth < 1200 ? 'd-none' : ''}`}
              >
                <li>
                  <span onClick={() => handleChangeLanguage('ar')}>
                    <img src='/img/Flags/lb.svg' alt='LB' height={25} /> العربية
                  </span>
                </li>
                <li>
                  <span onClick={() => handleChangeLanguage('en')}>
                    <img src='/img/Flags/gb.svg' alt='GB' height={25} />
                    English
                  </span>
                </li>
                {/* <li>
                  <Link to='/de'>
                    <img src='/img/Flags/de.svg' alt='DE' height={25} />
                    Deutsch
                  </Link>
                </li> */}
              </ul>
            </li>
          </ul>
          <span onClick={() => toggleMobileNav()}>
            <FontAwesomeIcon
              icon={isMobileNavActive ? 'x' : 'bars'}
              size='xl'
              className={`${styles['mobile-nav-toggle']} d-xl-none`}
            />
          </span>
        </nav>
      </div>
    </header>
  )
}

export default Header
